var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.002,
    height: 23.998,
    viewBox: "0 0 24.002 23.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(-480 -799.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_49",
    "data-name": "Subtraction 49",
    d: "M11121,19563c-.063,0-.149,0-.255-.01h-.01c-.036,0-.072-.006-.109-.01h-.006a.291.291,0,0,0-.039-.006.252.252,0,0,0-.038,0,.076.076,0,0,0-.029,0,.159.159,0,0,1-.048-.01l-.006,0-.02,0-.01,0h-.006c-.006,0-.008,0-.009,0h-.01l-.011,0h-.012l-.032-.006a.083.083,0,0,0-.021,0,.227.227,0,0,0-.032-.006.016.016,0,0,0-.015-.006,3.7,3.7,0,0,1-2.6-2.014h6.629a3.71,3.71,0,0,1-2.593,2.016,0,0,0,0,0,0,0,.02.02,0,0,0-.011,0l-.044.006-.015,0a.231.231,0,0,1-.033.008h-.01l-.012,0-.02,0a.021.021,0,0,1-.015,0h-.02l-.045.008-.017,0a1.973,1.973,0,0,1-.219.023C11121.171,19563,11121.093,19563,11121,19563Zm8.906-3.127h-17.812a2.1,2.1,0,0,1-2.092-2.092v-1.311a.376.376,0,0,1,.04-.014,4.716,4.716,0,0,0,2.138-1.574,7.555,7.555,0,0,0,1.318.115,7.738,7.738,0,0,0,.982-.064,6.786,6.786,0,0,1-2.479,2.779v.068a.093.093,0,0,0,.093.09h17.813a.093.093,0,0,0,.093-.09v-.068a6.8,6.8,0,0,1-3.093-4.85v-.025l-.01-.094a5.541,5.541,0,0,1-.039-.7v-4.174a5.844,5.844,0,0,0-4.714-5.717l-1.144-.225-1.139.225a6,6,0,0,0-.869.242,7.6,7.6,0,0,0-1.755-1.4,7.751,7.751,0,0,1,2.235-.807,1.575,1.575,0,0,1,3.055,0,7.848,7.848,0,0,1,6.328,7.678v4.174a4.152,4.152,0,0,0,.029.5v.01a4.731,4.731,0,0,0,3.118,3.922v1.311A2.1,2.1,0,0,1,11129.906,19559.873Z",
    transform: "translate(-10628.001 -18740)",
    fill: "#ebecff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "indicator",
    d: "M1982.5,14a5.5,5.5,0,1,0-5.5-5.5A5.507,5.507,0,0,0,1982.5,14Z",
    transform: "translate(-1497.001 799)",
    fill: "#fd1a64"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e1303cdc.svg";
export { ForwardRef as ReactComponent };